import { useQuery } from "@tanstack/react-query";
import { notificationApi } from "../api";
import type { NotificationAudience } from "../api/interfaces";

export const UNREAD_COUNT_REFETCH_INTERVAL_MS = 5 * 60 * 1000;

/**
 * Shared notification-count behavior with no rendering policy. Audience apps
 * own their icon/button presentation while this hook preserves refresh and
 * cross-user cache safety.
 */
export function useNotificationUnreadCount(
  audience?: NotificationAudience,
): number {
  const { data } = useQuery({
    queryKey: ["notifications", "unread-count", audience],
    queryFn: async () => {
      const result = await notificationApi.list({
        limit: 50,
        offset: 0,
        audience,
      });
      return result.items.filter((notification) => !notification.is_read)
        .length;
    },
    refetchInterval: UNREAD_COUNT_REFETCH_INTERVAL_MS,
    staleTime: UNREAD_COUNT_REFETCH_INTERVAL_MS,
    refetchOnWindowFocus: "always",
    refetchOnReconnect: "always",
    gcTime: 0,
    refetchOnMount: "always",
  });

  return data ?? 0;
}
